module.exports = __webpack_public_path__ + "img/team-1-1.f8cf3905.jpeg";